import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Small } from 'foundations-components/transitional/components/Small';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { useAuthState } from '../../app/hooks/useAuthState';
import { GATES_MANUALLY_DISABLED_LEAVE_BETA } from '../constants';
import { isAllowedToLeaveBeta, isEnrolled } from './utils/enrollmentStatus';
import EditBetaDialog from './EnrollmentButtonDialogs/EditBetaDialog';
import { PRIVATE_BETA } from '../RolloutTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RolloutProductUpdateStatusTagBeta = ({
  id,
  rolloutId,
  title,
  untranslatedTitle,
  gate,
  enrollmentStatus,
  enrollType,
  betaPaused,
  rolloutState
}) => {
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const {
    portal,
    hasBetaAccess
  } = useAuthState();
  const enrolled = isEnrolled(enrollmentStatus);
  const enrolledAndCanLeave = isAllowedToLeaveBeta(enrollmentStatus) && hasBetaAccess;
  const automaticallyEnrolled = enrollmentStatus === 'ENROLLED_CANNOT_LEAVE' && !GATES_MANUALLY_DISABLED_LEAVE_BETA.includes(gate);
  const disabled = enrollType !== 'USERS_AND_PORTALS' || betaPaused;
  const isSlowRollout = portal && portal.isSlowRollout;
  const betaAccessType = rolloutState === PRIVATE_BETA ? 'PRIVATE' : 'PUBLIC';
  const enrollmentMessage = automaticallyEnrolled ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: `app.statusTags.${rolloutState}_AUTOMATIC`
  }) : enrollmentStatus === 'PORTAL' || enrollmentStatus === 'ORGANIZATION' ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: `app.statusTags.${rolloutState}_EVERYONE`
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: `app.statusTags.${rolloutState}_YOU`
  });
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(StatusTag, {
      use: "warning",
      children: enrolled ? enrollmentMessage : /*#__PURE__*/_jsx(FormattedMessage, {
        message: `app.statusTags.${rolloutState}_NOT`
      })
    }), enrolledAndCanLeave && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Tooltip, {
        disabled: !disabled,
        title: enrollType !== 'USERS_AND_PORTALS' ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.detailsPanel.editAccessNotSupportedTooltip"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.detailsPanel.editAccessTooltip"
        }),
        children: /*#__PURE__*/_jsx(Button, {
          use: "link",
          marginInlineStart: "100",
          disabled: disabled,
          onClick: () => {
            setEditDialogOpen(true);
          },
          children: /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.statusTags.EDIT"
            })
          })
        })
      }), editDialogOpen && /*#__PURE__*/_jsx(EditBetaDialog, {
        id: id,
        rolloutId: rolloutId,
        betaAccessType: betaAccessType,
        enrollmentStatus: enrollmentStatus,
        enrollType: enrollType,
        title: title,
        untranslatedTitle: untranslatedTitle,
        gate: gate,
        isSlowRollout: isSlowRollout,
        onClose: () => {
          setEditDialogOpen(false);
        }
      })]
    })]
  });
};
export default RolloutProductUpdateStatusTagBeta;